import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/together/footer';
import Header from '../components/together/header';
import HomePage from '../pages/together/home_page';
import AboutPage from '../pages/together/about_page';
import ContactPage from '../pages/together/contact_page';


export default function TogetherTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
                
            />
            <Footer />
        </React.Fragment>
    )
}
